import {apiBase} from 'api/base.js';

const InstantRakeTasksAPI = {
  create: (params) => {
    return apiBase.post('/admin/instant_rake_execute', params);
  }
};

export {InstantRakeTasksAPI as instantRakeTasksAPI};
